import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enLocale from "../util/locales/enLocale";
import mkLocale from "../util/locales/mkLocale";
import alLocale from "../util/locales/alLocale";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translations: enLocale
            },
            mk: {
                translations: mkLocale
            },
            al: {
                translations: alLocale
            }
        },
        lng: "mk",
        fallbackLng: "en",
        debug: process.env.NODE_ENV !== 'production',

        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
